/* eslint-disable camelcase */
import { useMemo, useState } from "react"
import {
  MaterialReactTable,
  // createRow,
  useMaterialReactTable,
} from "material-react-table"
import { createTheme, ThemeProvider, useTheme, Box, Button, IconButton, Tooltip } from "@mui/material"
import { esES } from "@mui/material/locale"
import { MRT_Localization_ES } from "material-react-table/locales/es"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import EditIcon from "@mui/icons-material/Edit"
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import { useNavigate } from "react-router-dom"
import CrearIcon from "../../../assets/iconos/Crear.ico"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"

const CustomTable = ({ fetchedInfo = [], isLoadingInfoError, isLoadingInfo, isFetchingInfo }) => {
  const navigate = useNavigate()

  const columns = useMemo(
    () => [
      {
        accessorFn: (row) => row?.cabecera?.tranumero,
        header: "Código de Ingreso",
        enableEditing: false,
        size: 200,
      },
      {
        accessorFn: (row) => row?.cabecera?.palletid,
        header: "Código Pallet",
        enableEditing: false,
        size: 200,
      },
      {
        accessorFn: (row) => row?.cabecera?.tradescripcion,
        header: "Observación",
        enableEditing: false,
        size: 120,
      },
      {
        accessorFn: (row) => row?.cabecera?.invdescri,
        header: "Inventario",
        enableEditing: false,
        size: 200,
      },
      {
        accessorFn: (row) => row?.cabecera?.boddescri,
        header: "Bodega",
        enableEditing: false,
        size: 200,
      },
      {
        accessorFn: (row) => row?.cabecera?.clinombre,
        header: "Cliente",
        enableEditing: false,
        size: 200,
      },
      {
        accessorFn: (row) => row?.cabecera?.izoncodigo,
        header: "Zona",
        enableEditing: false,
        size: 120,
      },
      {
        accessorFn: (row) => row?.cabecera?.bahcodigo,
        header: "Bahía",
        enableEditing: false,
        size: 120,
      },
      {
        accessorFn: (row) => row?.cabecera?.pascodigo,
        header: "Pasillo",
        enableEditing: false,
        size: 120,
      },
      {
        accessorFn: (row) => row?.cabecera?.nivcodigo,
        header: "Nivel",
        enableEditing: false,
        size: 120,
      },
      {
        accessorFn: (row) => row?.cabecera?.poscodigo,
        header: "Posición",
        enableEditing: false,
        size: 120,
      },
      {
        accessorFn: (row) => row?.cabecera?.fechaIngreso,
        header: "Fecha Ingreso",
        enableEditing: false,
        size: 120,
        Cell: ({ cell }) => <div>{normalFormatDate(cell.getValue())}</div>,
      },
    ],
    [],
  )

  const table = useMaterialReactTable({
    columns,
    data: fetchedInfo,
    enableEditing: true,
    enableRowActions: true,
    localization: { ...MRT_Localization_ES },
    getRowId: (row) => row?.cabecera?.tranumero,
    muiToolbarAlertBannerProps: isLoadingInfoError
      ? {
          color: "error",
          children: "Error en cargar las Solicitudes Ingresos",
        }
      : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: "500px",
      },
    },

    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex", gap: "1rem" }}>
        <Tooltip title="Ver">
          <IconButton
            onClick={() => {
              navigate(`articulos`, {
                state: row?.original,
              })
            }}
          >
            <RemoveRedEyeIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),
    state: {
      isLoading: isLoadingInfo,
      showAlertBanner: isLoadingInfoError,
      showProgressBars: isFetchingInfo,
    },
  })

  return <MaterialReactTable table={table} />
}

const IngresoInventarioReadable = (params) => {
  const theme = useTheme()
  return (
    <div>
      <ThemeProvider theme={createTheme(theme, esES)}>
        <CustomTable {...params} />
      </ThemeProvider>
    </div>
  )
}

export default IngresoInventarioReadable
